var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type=='InstrumentUltimateTzCheckMeBack')?_c('CheckMeBack',{attrs:{"customer":_vm.customer,"instrument":_vm.instrument}}):_c('SalaryAdvance',{attrs:{"customer":_vm.customer,"instrument":_vm.instrument}})}
var staticRenderFns = []

export { render, staticRenderFns }